import React, { useState, useEffect } from "react";
import "./datatable.scss";
import { Link } from "react-router-dom";
import { Accordion, Pagination } from "react-bootstrap"
import { parseInt } from "lodash";

const StakingTable = ({ setCurrentPage, currentPage, pageSize, indexwaits, activeDepositCount, activeDeposit, account, getDepositData }) => {

  // console.log("data here", activeDepositCount)
  // Function to convert timestamp to date and time
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return date?.toLocaleString('en-GB', options).split(', ');
  };
  useEffect(() => {
    if (account && currentPage === 1 || indexwaits === 'MYSTAKING') {
      getDepositData(currentPage, pageSize)
    } else if (account || indexwaits === 'MYSTAKING') {
      getDepositData(currentPage, pageSize)
    }
    // getDepositData(currentPage, pageSize);
  }, [account, currentPage, indexwaits]);


  const totalPages = Math.ceil(activeDepositCount / pageSize);

  return (
    <>
      <div className="mytable">
        <section className="datatable">
          <div className="bgtable">
            <div className="table-responsive" style={{ position: "relative" }}>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div
                        className="parent-tag"
                      >
                        Date
                        <div
                          className="filter-btn"
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            width="9"
                            height="6"
                            viewBox="0 0 9 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.90908 5.14258H4.09498H0.660442C0.072714 5.14258 -0.22115 4.36198 0.195157 3.90439L3.36644 0.418619C3.87458 -0.139912 4.70107 -0.139912 5.20921 0.418619L6.41528 1.74429L8.38049 3.90439C8.79068 4.36198 8.49681 5.14258 7.90908 5.14258Z"
                              fill="#626C78"
                            />
                          </svg>
                          <svg
                            width="9"
                            height="6"
                            viewBox="0 0 9 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.90908 0.857422H4.09498H0.660442C0.072714 0.857422 -0.22115 1.63802 0.195157 2.09561L3.36644 5.58138C3.87458 6.13991 4.70107 6.13991 5.20921 5.58138L6.41528 4.25571L8.38049 2.09561C8.79068 1.63802 8.49681 0.857422 7.90908 0.857422Z"
                              fill="#626C78"
                            />
                          </svg>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                      >
                        Activity
                      </div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                      >
                        AMOUNT STAKED

                      </div>
                    </th>

                    <th>
                      <div className="parent-tag">
                        TX Hash
                        <div
                          className="filter-btn"
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            width="9"
                            height="6"
                            viewBox="0 0 9 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.90908 5.14258H4.09498H0.660442C0.072714 5.14258 -0.22115 4.36198 0.195157 3.90439L3.36644 0.418619C3.87458 -0.139912 4.70107 -0.139912 5.20921 0.418619L6.41528 1.74429L8.38049 3.90439C8.79068 4.36198 8.49681 5.14258 7.90908 5.14258Z"
                              fill="#626C78"
                            />
                          </svg>
                          <svg
                            width="9"
                            height="6"
                            viewBox="0 0 9 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.90908 0.857422H4.09498H0.660442C0.072714 0.857422 -0.22115 1.63802 0.195157 2.09561L3.36644 5.58138C3.87458 6.13991 4.70107 6.13991 5.20921 5.58138L6.41528 4.25571L8.38049 2.09561C8.79068 1.63802 8.49681 0.857422 7.90908 0.857422Z"
                              fill="#626C78"
                            />
                          </svg>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {activeDeposit?.map((deposit, index) => {
                    // console.log("time", deposit)
                    const [date, time] = formatTimestamp(deposit?.blockTimestamp);
                    return (
                      <tr key={index}>
                        <td>
                          <div className="stakingdatesmain">
                            <h6 className="datepara">    {new Date(
                              deposit?.blockTimestamp * 1000
                            ).toLocaleDateString()}</h6>
                            <p className="timepara">   {new Date(
                              deposit?.blockTimestamp * 1000
                            ).toLocaleTimeString()}</p>
                          </div>
                        </td>
                        <td>Staked</td>
                        <td>{(deposit?.amount / 1e18).toLocaleString()} DOP</td>
                        <td>
                          <a href={`https://etherscan.io/tx/${deposit?.transactionHash}`} target="_blank" className="hashpara">
                            {deposit?.transactionHash?.slice(0, 6)}...{deposit?.transactionHash?.slice(-4)}
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M7.5835 6.41663L12.3668 1.6333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12.8332 3.96675V1.16675H10.0332" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M6.4165 1.16675H5.24984C2.33317 1.16675 1.1665 2.33341 1.1665 5.25008V8.75008C1.1665 11.6667 2.33317 12.8334 5.24984 12.8334H8.74984C11.6665 12.8334 12.8332 11.6667 12.8332 8.75008V7.58342" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {
              activeDepositCount > 0 &&
              (
                <div className="footer-content">

                  <div className="left-f">
                    <h6>
                      SHOWING {currentPage * pageSize - pageSize + 1}-
                      {Math.min(currentPage * pageSize, activeDepositCount)} OF {activeDepositCount}
                    </h6>
                  </div>
                  <div className="right-f">
                    <Pagination>
                      <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} />
                      {[...Array(Math.ceil(activeDepositCount / pageSize)).keys()].map(number => (
                        <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => setCurrentPage(number + 1)}>
                          {number + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} />
                    </Pagination>
                  </div>
                </div>
              )
            }

          </div>
        </section>
      </div>

      <div className="mytablemobile d-none">
        <div className="mainupperr">
          {activeDeposit?.map((deposit, index) => {
            const [date] = formatTimestamp(deposit?.claimTime);
            return (
              <div className="mbltable">
                <div className="mbltableinner">
                  <div className="mbltabledetail">
                    <p className="mblpara">DATE</p>
                    <h6 className="mblhead"> {new Date(
                      deposit?.blockTimestamp * 1000
                    ).toLocaleDateString()}</h6>
                  </div>
                  <div className="mbltabledetail">
                    <p className="mblpara">TX HASH</p>
                    <a href={`https://etherscan.io/tx/${deposit?.transactionHash}`} className="mblheadlink">
                      {deposit.transactionHash.slice(0, 6)}...{deposit.transactionHash.slice(-4)}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                      >
                        <path
                          d="M6.5 6.00002L10.6 1.90002"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.0001 3.9V1.5H8.6001"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.5 1.5H4.5C2 1.5 1 2.5 1 5V8C1 10.5 2 11.5 4.5 11.5H7.5C10 11.5 11 10.5 11 8V7"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="mbltableinner">
                  <div className="mbltabledetail">
                    <p className="mblpara">ACTIVITY</p>
                    <h6 className="mblhead">Staked</h6>
                  </div>
                  <div className="mbltabledetail">
                    <p className="mblpara">AMOUNT STAKED</p>
                    <p className="mblhead">{(deposit?.amount / 1e18).toLocaleString()} DOP</p>
                  </div>
                </div>
              </div>
            )
          })}

          {
            activeDepositCount > 0 &&
            (
              <div className="footer-content">
                <div className="left-f">
                  <h6>
                    SHOWING {currentPage * pageSize - pageSize + 1}-
                    {Math.min(currentPage * pageSize, activeDepositCount)} OF {activeDepositCount}
                  </h6>
                </div>
                <div className="right-f">
                  <Pagination>
                    <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} ><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M13.1588 4.40832C13.2369 4.48579 13.2989 4.57796 13.3412 4.67951C13.3835 4.78106 13.4053 4.88998 13.4053 4.99999C13.4053 5.11 13.3835 5.21892 13.3412 5.32047C13.2989 5.42202 13.2369 5.51418 13.1588 5.59165L9.34211 9.40832C9.264 9.48579 9.20201 9.57796 9.1597 9.67951C9.11739 9.78106 9.09561 9.88998 9.09561 9.99999C9.09561 10.11 9.11739 10.2189 9.1597 10.3205C9.20201 10.422 9.264 10.5142 9.34211 10.5917L13.1588 14.4083C13.2369 14.4858 13.2989 14.578 13.3412 14.6795C13.3835 14.7811 13.4053 14.89 13.4053 15C13.4053 15.11 13.3835 15.2189 13.3412 15.3205C13.2989 15.422 13.2369 15.5142 13.1588 15.5917C13.0026 15.7469 12.7914 15.834 12.5713 15.834C12.3511 15.834 12.1399 15.7469 11.9838 15.5917L8.15878 11.7667C7.69061 11.2979 7.42764 10.6625 7.42764 9.99999C7.42764 9.33749 7.69061 8.70207 8.15878 8.23332L11.9838 4.40832C12.1399 4.25311 12.3511 4.16599 12.5713 4.16599C12.7914 4.16599 13.0026 4.25311 13.1588 4.40832Z" fill="#C1C8CB" />
                    </svg> </Pagination.Prev>
                    {[...Array(Math.ceil(activeDepositCount / pageSize)).keys()].map(number => (
                      <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => setCurrentPage(number + 1)}>
                        {number + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} ><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M6.84122 4.40832C6.76312 4.48579 6.70112 4.57796 6.65881 4.67951C6.61651 4.78106 6.59473 4.88998 6.59473 4.99999C6.59473 5.11 6.61651 5.21892 6.65881 5.32047C6.70112 5.42202 6.76312 5.51418 6.84122 5.59165L10.6579 9.40832C10.736 9.48579 10.798 9.57796 10.8403 9.67951C10.8826 9.78106 10.9044 9.88998 10.9044 9.99999C10.9044 10.11 10.8826 10.2189 10.8403 10.3205C10.798 10.422 10.736 10.5142 10.6579 10.5917L6.84123 14.4083C6.76312 14.4858 6.70112 14.578 6.65882 14.6795C6.61651 14.7811 6.59473 14.89 6.59473 15C6.59473 15.11 6.61651 15.2189 6.65882 15.3205C6.70112 15.422 6.76312 15.5142 6.84123 15.5917C6.99736 15.7469 7.20857 15.834 7.42873 15.834C7.64888 15.834 7.86009 15.7469 8.01622 15.5917L11.8412 11.7667C12.3094 11.2979 12.5724 10.6625 12.5724 9.99999C12.5724 9.33749 12.3094 8.70207 11.8412 8.23332L8.01622 4.40832C7.86009 4.25311 7.64888 4.16599 7.42872 4.16599C7.20857 4.16599 6.99736 4.25311 6.84122 4.40832Z" fill="#212121" />
                    </svg> </Pagination.Next>
                  </Pagination>
                </div>
                {/* <div className="right-f">
                <Pagination>
                    <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} />
                    {[...Array(15).keys()].map(number => (
                        <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => setCurrentPage(number + 1)}>
                            {number + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage(prev => prev + 1)} />
                </Pagination>
            </div> */}
              </div>
            )
          }

        </div>

      </div>
    </>
  );
};

export default StakingTable;
